import { render, staticRenderFns } from "./ClinicEdit.vue?vue&type=template&id=71b4450e&scoped=true"
import script from "./ClinicEdit.vue?vue&type=script&lang=js"
export * from "./ClinicEdit.vue?vue&type=script&lang=js"
import style0 from "./ClinicEdit.vue?vue&type=style&index=0&id=71b4450e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b4450e",
  null
  
)

export default component.exports